// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__U7vMF","errors":"Errors_errors__o0vJH"};